import { useEffect } from 'react'

import { useGatewaySettingsStore } from '@/core/stores/gatewaySettingsStore'

export function useGatewayUserSettings() {
  const settings = useGatewaySettingsStore((state) => state.settings)
  const hydrate = useGatewaySettingsStore((state) => state.hydrate)
  const applyGatewaySettings = useGatewaySettingsStore((state) => state.applyGatewaySettings)
  const resetGatewaySettings = useGatewaySettingsStore((state) => state.resetGatewaySettings)

  useEffect(() => {
    hydrate()
  }, [hydrate])

  return {
    gatewaySettings: settings,
    applyGatewaySettings,
    resetGatewaySettings,
  }
}
